(function () {
    'use strict';

    function formSearchConfiguration() {
        return {
            restrict: 'E',
            templateUrl: 'siteConfiguration/directives/templates/formSearchConfiguration.html',
            link: function (scope) {
            }
        };
    }

    formSearchConfiguration.$inject = [];

    angular.module('ecap.siteConfiguration').directive('formSearchConfiguration', formSearchConfiguration);
})();

